export const COLOR_PRIMARY_GREEN = 'rgba(35, 104, 71, 1)';
export const COLOR_SECONDARY_GREEN = 'rgba(101, 150, 127, 1)';
export const COLOR_TERTIARY_GREEN = 'rgba(167, 195, 181, 1)';
